import { NavLink } from 'react-router';
import { Home } from '../icons/Home';
import { Checkmark } from '../icons/Checkmark';
import { Group } from '../icons/Group';

export function Nav() {
  return (
    <nav>
      <div className="rounded-3xl w-11/12 mx-auto mb-2 p-1 text-xs bg-white flex justify-evenly gap-2">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `w-1/3 p-3 ${isActive ? 'pointer-events-none' : 'pointer-events-auto'}`
          }
          aria-label="Home"
        >
          {({ isActive }) => (
            <div className="flex flex-col items-center">
              <Home
                className={
                  isActive
                    ? 'fill-primary'
                    : 'fill-disabled hover:fill-secondary transition-all'
                }
                width={40}
                height={40}
              />
              <div
                className={`h-1 rounded w-6 mt-1 transition-all duration-300 ${isActive ? 'bg-primary' : 'bg-transparent'}`}
              />
            </div>
          )}
        </NavLink>
        <NavLink
          to="/goals"
          className={({ isActive }) =>
            `w-1/3 p-3 ${isActive ? 'pointer-events-none' : 'pointer-events-auto'}`
          }
          aria-label="Goals"
        >
          {({ isActive }) => (
            <div className="flex flex-col items-center">
              <Checkmark
                className={
                  isActive
                    ? 'fill-primary'
                    : 'fill-disabled hover:fill-secondary transition-all'
                }
                width={40}
                height={40}
              />
              <div
                className={`h-1 rounded w-6 mt-1 transition-all duration-300 ${isActive ? 'bg-primary' : 'bg-transparent'}`}
              />
            </div>
          )}
        </NavLink>
        <NavLink
          to="/students"
          className={({ isActive }) =>
            `w-1/3 p-3 ${isActive ? 'pointer-events-none' : 'pointer-events-auto'}`
          }
          aria-label="Students"
        >
          {({ isActive }) => (
            <div className="flex flex-col items-center">
              <Group
                className={
                  isActive
                    ? 'fill-primary'
                    : 'fill-disabled hover:fill-secondary transition-all'
                }
                width={40}
                height={40}
              />
              <div
                className={`h-1 rounded w-6 mt-1 transition-all duration-300 ${isActive ? 'bg-primary' : 'bg-transparent'}`}
              />
            </div>
          )}
        </NavLink>
      </div>
    </nav>
  );
}
